import React, { FC } from 'react';

const WithServices = (WrappedComponent: FC<any>, providers: FC<any>[]) => {
	const wrap = (child: JSX.Element, Provider: FC<any>) => <Provider>{child}</Provider>;

	return (props: any) => (
		<>
			{providers.length > 0 &&
				providers.reduce((res, provider) => {
					return wrap(res, provider);
				}, <WrappedComponent {...props} />)}
		</>
	);
};

export default WithServices;
